module.exports = __webpack_public_path__ + "static/media/ori_naama.3ff4b974.jpg";